import DollarImage from "../../assets/images/assad_arcade_category/dollar.png";
import addFriendIcon from "../../assets/images/assad_arcade_category/add_friend.svg";
import buttonBg from "../../assets/images/assad_arcade_category/btnBg_small.png"
import IconComponent from "./IconComponent";
import { useEffect } from "react";
import { readMessageAction } from "../../redux/actions/assad_arcade/AssadMessageActions";
import { AddAssadCoinAction } from "../../redux/actions/assad_arcade/AssadGameAction";
import { useDispatch } from "react-redux";
import { fireConfetti } from "../../utils/confetti";

let defaultModalData = {
	status: 0,
	readDate: null,
	_id: "66a9061c7144339c1ac7b284",
	createdDate: "2024-07-30T15:26:20.873Z",
	user: "66a25c056b94ced564deaac0",
	gameId: "assad.game",
	type: "friend_referral",
	title: "New Friend Joined",
	text: "Your friend has joined the game",
	buttons: [
		{
			text: "Great",
			action: "close"
		},
		{
			text: "Invite",
			action: "window.Telegram.WebApp.openTelegramLink()",
			icon: "../../assets/images/assad_arcade_category/add_friend.svg",
			action_url: "https://t.me/share/url?url=https://t.me/Celery_Cosmos_bot?start=66a8d0df547f430a5024a11b"
		}
	],
	action: "arcade_coins",
	image: null,
	data: {
		friends: 1,
		Coins: 5000
	},
	__v: 0
};

const CustomCategoryPopup = ({
	isModalOpen = true,
	closeModal,
	modalData = defaultModalData,
	...props
}) => {
	const dispatch = useDispatch();
	let showButtons = modalData?.buttons && modalData?.buttons?.length > 0; 

	const executeCode = (resultString,url) => {
		try {
		//    const result = eval(`${resultString}('${url}')`);
		   closeModal();
	   } catch (error) {
		   closeModal();
	   }
   };

	const handleClick=(buttonDetail)=>{		
		if(buttonDetail?.action && buttonDetail?.action==='close'){
			closeModal();
		}else{
			let actionString = buttonDetail?.action;
			let actionTrimString = actionString.replace(/[()]/g, '');
			executeCode(actionTrimString,buttonDetail?.action_url);
		}
		dispatch(readMessageAction({messageId: modalData._id}));
	}

	const claimArcadeCoinsCallback = (arcade_coins)=>{
		const rewardCoins = parseInt(arcade_coins); 
		dispatch(AddAssadCoinAction({ amount: rewardCoins, coinType: 'click' })); 
	}

	useEffect(() => {
		if (modalData.action ==='claim_referral') {
			// dispatch(claimRewardActions({ user_id: user?.id, ref_type: 'friend' }, claimRewardUpdateCallback));
		}else if (modalData.action ==='arcade_coins') {
			//alert('arcade_coins',modalData.data.coins);
            //dispatch(claimRewardActions({ user_id: user?.id, ref_type: 'arcade' }), claimArcadeCoinsCallback);
			claimArcadeCoinsCallback(modalData.data.Coins);
			fireConfetti();
        }

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const formattedText = modalData?.text?.replace(/\n/g, "<br />");

	return (
		<div className="flex items-center flex-col justify-center fixed h-full z-[999] left-0 top-0 w-full ">
			{isModalOpen && (
				<div className="flex items-center justify-center flex-col">
					<div className="max-w-[300px] bg-[#030303] p-7 rounded-3xl shadow-[0px_0px_8px_rgba(164,142,56,1)]">
						<h3 className="text-center text-2xl leading-7 my-2 text-[#fff] font-bold"> {modalData?.title} </h3>
						<p
							className="text-left font-normal text-[14px] text-[#fff]"
							dangerouslySetInnerHTML={{ __html: formattedText }}
						></p>
						{modalData?.data && (
							<div className="flex items-center gap-2 justify-center mt-2 text-[#fff]">
								<span className="font-bold">{(modalData.data.Coins ? modalData.data.Coins : 0).toLocaleString()}</span>
								<img src={DollarImage} alt="" className="max-w-[25px]" />
							</div>
						)}
						{showButtons && (
							<div className="text-center">
								{modalData?.buttons.map((btn, index) => {
									return btn?.icon ? (
										<button key={`btn_key_${index}`} onClick={()=>handleClick(btn)} className="flex items-center justify-center gap-2 w-60 btnBg text-[#fff] mt-2 bg-center bg-cover text-center mx-auto h-[66px] max-w-[180px]" style={{ backgroundImage: `url(${buttonBg})` }} >
											<span className="font-semibold">{btn.text}</span>
											{
											btn?.text.toLowerCase() ==='invite' ?
												<img src={addFriendIcon} alt={btn.text} className="max-w-[20px]"  />
											:
												<IconComponent imgSrc={btn.icon} alt={`${btn.text}_button_img`}   />
											}

										</button>
									) : (
										<button key={`btn_key_${index}`}  onClick={()=>handleClick(btn)} className="w-60 btnBg text-[#fff] mt-2 font-semibold bg-center bg-cover text-center mx-auto h-[66px] max-w-[180px]" style={{ backgroundImage: `url(${buttonBg})` }} >
											<span>{btn.text}</span>
										</button>
									);
								})}
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default CustomCategoryPopup;
